import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import ConstructionWebsite from "./ConstructionWebsite";

function App() {
  useEffect(() => {
    AOS.init({
      duration: 1000, // animation duration in ms
      once: true,     // whether animation should happen only once
      easing: "ease-out-cubic", // smoother easing
    });
  }, []);

  return <ConstructionWebsite />;
}

export default App;
